"use strict";

var _interopRequireDefault = require("/www/wwwroot/check/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.regexp.replace");
var _request = _interopRequireDefault(require("@/utils/request"));
var _fengkongDefaultReportNew = _interopRequireDefault(require("./fengkongDefaultReportNew.vue"));
// import FengkongDefaultReportOld from './fengkongDefaultReportOld.vue'

var VIEW_STORAGE_KEY = 'fengkong_default_report_view';
var _default = exports.default = {
  name: 'FengkongDefault',
  components: {
    FengkongDefaultReportNew: _fengkongDefaultReportNew.default
    // FengkongDefaultReportOld
  },
  data: function data() {
    // 暂只开放新版；老版入口已注释
    var viewMode = 'new';
    // const q = (this.$route && this.$route.query && this.$route.query.view) || ''
    // let viewMode = 'new'
    // if (q === 'old' || q === 'new') {
    //   viewMode = q
    // } else {
    //   try {
    //     const saved = localStorage.getItem(VIEW_STORAGE_KEY)
    //     if (saved === 'old' || saved === 'new') viewMode = saved
    //   } catch (e) { /* ignore */ }
    // }
    return {
      viewMode: viewMode,
      data: {},
      member: {},
      time: {},
      currentId: 0,
      loading: false
    };
  },
  created: function created() {
    this.currentId = this.$route.query.id;
    this.getInfo(this.currentId);
  },
  methods: {
    onViewChange: function onViewChange(mode) {
      // 老版已注释，仅允许新版
      if (mode !== 'new') return;
      this.viewMode = mode;
      try {
        localStorage.setItem(VIEW_STORAGE_KEY, mode);
      } catch (e) {/* ignore */}
      var query = Object.assign({}, this.$route.query, {
        view: mode
      });
      this.$router.replace({
        query: query
      }).catch(function () {});
    },
    getInfo: function getInfo(id) {
      var _this = this;
      if (!id) return;
      this.loading = true;
      (0, _request.default)({
        url: "/system/report/get_fengkong_info/",
        method: 'get',
        params: {
          shop_id: this.$user.data.shop,
          record_id: id
        }
      }).then(function (res) {
        _this.data = res.data.results || {};
        _this.member = res.data.user_info || {};
        _this.time = res.data.time || res.data.record || {};
        if (_this.data.channel_errors && Object.keys(_this.data.channel_errors).length) {
          var tip = Object.keys(_this.data.channel_errors).map(function (k) {
            return "".concat(k, ":").concat(_this.data.channel_errors[k]);
          }).join('；');
          _this.$message({
            message: '部分通道异常：' + tip,
            type: 'warning',
            duration: 6000
          });
        }
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
};